import { QueryClient } from '@tanstack/react-query';

/**
 * Client de requetes partage.
 *
 * `staleTime` a 30 s : les donnees du referentiel changent peu ; on evite les
 * refetch a chaque montage sans figer l'affichage. Le polling du planning
 * (lot 4) configurera son propre intervalle sur ses requetes.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
